module.exports = __webpack_public_path__ + "img/fondo-teamx2.615df608.jpg";